var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('app-layout'):_c('login-layout')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70b030e9","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 1930
// module chunks = 0